import _ from 'lodash'
import moment from 'moment'
import { useNavigate } from 'react-router-dom'
import { useEffect, useState } from 'react'
import styled from 'styled-components'

import api from '../../services/api'
import useModal from '../../hooks/useModal'

import { BasicBtn } from '../../components/Buttons'
import BasicPagination from '../../components/Paginations'
import ReportingStatus from '../../components/ReportingStatus'

import { ReactComponent as ReportIcon } from '../../assets/images/menu/report_icon.svg'

export default function ReportList() {
  const [report, setReport] = useState()
  const [reportingStatus, setReportStatus] = useState()
  const { openModal } = useModal()
  const navigate = useNavigate()
  const limit = 7
  const date = moment().format('YYYY-MM-DD')

  useEffect(() => {
    api.get('/reports/lists', { params: { page: 1, limit } })
      .then(result => setReport(result.data))
      .catch(console.error)

    api.get(`/reports/infos/reporting-status/${date}`)
      .then(result => setReportStatus(result.data.reportingStatus.thisYear))
      .catch(console.error)
  }, [])

  const handlePageChange = (e, v) => {
    api.get('/reports/lists', { params: { page: v, limit } })
      .then(result => setReport(result.data))
      .catch(console.error)
  }

  const handleAddReportClick = () => {
    api.get(`/reports/infos/types/${date}`)
      .then(result => {
        const { reportTypeList } = result.data
        if (reportTypeList.length === 1) {
          navigate(`../write?reportTypeId=${reportTypeList[0].reportTypeId}&date=${date}`)
        } else {
          openModal({ type: 'selectReportType', props: { reportTypeList: reportTypeList, date } })
        }
      })
      .catch((e) => {
        console.error(e)
        const props = {
          type: 'alert',
          props: {
            isError: true,
            contents: e.response?.data.message || e.message,
            path: e.response?.status === 404 ? '/main/planner/sessional-plan' : undefined
          }
        }
        openModal(props)
      })
  }

  return (
    <PageWrapper>
      <Header>
        <TitleWrapper>
          <ReportIcon className="title-icon" width="2em" fill="black" />
          <div>
            <h1>리포트</h1>
            <p>그 동안 계획을 얼마나 달성했는지, 잘 집중했는지 확인해보고 스스로 피드백 해보세요.</p>
          </div>
        </TitleWrapper>
        <BasicBtn height="40px" width="120px" onClick={handleAddReportClick}>리포트 추가</BasicBtn>
      </Header>
      <ReportingSection>
        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '20px'}}>
          <ReportingStatus name="연간 리포트" reportStatusList={[reportingStatus?.annuallyReportingStatus]}/>
          <ReportingStatus name="반기 리포트" reportStatusList={reportingStatus?.biannuallyReportingStatusList}/>
          <ReportingStatus name="월간 리포트" reportStatusList={reportingStatus?.thisBiannually?.monthlyReportingStatusList}/>
          <ReportingStatus name="주간 리포트" reportStatusList={reportingStatus?.thisBiannually?.thisMonthly?.weeklyReportingStatusList}/>
        </div>
        <p>
          <span className="total-count">{parseInt(report?.pagination?.totalNum).toLocaleString('ko-KR')}</span> 개의 리포트가 있어요
        </p>
        <List>
          {_.map(report?.reportList, rl => (
            <ReportItem key={rl.reportId}
                        onClick={() => navigate(`../${rl.reportId}?reportTypeId=${rl.reportTypeId}&date=${rl.reportOn}`)}>
              <ReportIcon className="title-icon" width="1.5em" fill="gray"/>
              <p><span className="log-date">[{rl.reportOn}]</span>&emsp;{rl.reportTypeNameEn} 리포트</p>
            </ReportItem>
          ))}
        </List>
      </ReportingSection>

      <PaginationWrapper>
        <BasicPagination totalPage={report?.pagination.totalPage} onChange={handlePageChange}/>
      </PaginationWrapper>
    </PageWrapper>
  )
}

const PageWrapper = styled.div`
  margin: 30px;
  position: relative;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
`
const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  h1 {
    font-size: 2rem;
    font-weight: bold;
    color: #333;
    margin: 0;
  }

  p {
    font-size: 1rem;
    color: #777;
    margin-top: 8px;
  }
`


const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 30px;
`

const ReportingSection = styled.div`
  width: 100%;
  max-width: 900px;
  padding: 0 20px;
  text-align: center;

  .total-count {
    font-weight: bold;
    color: ${props => props.theme.colors.muiPrimary};
    font-size: 1.2em;
  }
`

const List = styled.div`
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`

const ReportItem = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 14px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background-color: #fff;
  transition: all 0.3s ease;
  width: 100%;
  max-width: 700px;
  margin: 0 auto;

  &:hover {
    background-color: #f7f7f7;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  }

  .title-icon {
    margin-right: 12px;
  }

  p {
    font-size: 1.2em;
    color: #333;
  }

  .log-date {
    font-weight: bold;
    color: ${props => props.theme.colors.muiPrimary};
  }
`

const HR = styled.hr`
  margin: 0;
  background: ${props => props.theme.colors.lightGray};
  height: 1px;
  width: 100%;
`

const PaginationWrapper = styled.div`
  margin-top: 30px;
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 20px 0;
`
